export class LibrarySearchSelect {
	activeClass = 'library-search-select--active';
	fillCLass = 'library-search-select--fill';

	constructor (element) {
		this.element = element;
		if (!this.element) return;
		this.current = this.element?.querySelector('.library-search-select__current');
		this.input = this.element?.querySelector('.library-search-select__input');
		this.init();
	}

	windowClickHandler = ({ target }) => {
		if (!this.element.contains(target)) {
			this.close();
			window.removeEventListener('click', this.windowClickHandler);
		}
	};

	open = () => {
		this.element.classList.add(this.activeClass);
		setTimeout(() => window.addEventListener('click', this.windowClickHandler), 33);
	};

	close = () => {
		this.element.classList.remove(this.activeClass);
		window.removeEventListener('click', this.windowClickHandler);
	};

	toggle = () => {
		if (this.element.classList.contains(this.activeClass)) this.close();
		else this.open();
	};

	setCurrent = (option) => {
		this.current.innerText = option.innerText;
		this.element.classList.add(this.fillCLass);
		this.close();
	};

	clear = () => {
		this.current.innerText = '';
		this.element.classList.remove(this.fillCLass);
	};

	clearInput = () => {
		this.input.value = '';
		this.input.dispatchEvent(new Event('input'));
	};

	clickHandler = ({ target }) => {
		const isDropdown = target.closest('.library-search-select__dropdown');
		const isClear = target.closest('.library-search-select__clear');
		const isInputClear = target.closest('.library-search-select__input-clear');
		const option = target.closest('.library-search-select__option');
		if (!isDropdown && !isClear) this.toggle();
		else if (option) this.setCurrent(option);
		else if (isClear) this.clear();
		else if (isInputClear) this.clearInput();
	};

	init = () => {
		this.element.addEventListener('click', this.clickHandler);
	};
}
